import { render, staticRenderFns } from "./DashboardWhatsAppModal.vue?vue&type=template&id=e38a9648&"
import script from "./DashboardWhatsAppModal.vue?vue&type=script&lang=js&"
export * from "./DashboardWhatsAppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports